// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { IContactData, contactData } from 'src/app/features/contact/models/contact-data';
import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { contactTypeDto, ContactTypeDto, IContactTypeDto } from './contact-type-dto.g';
import { IImageDto } from './image-dto.g';
import { IImageBoxDto } from './image-box-dto.g';
import { IContactTypeListDto } from './contact-type-list-dto.g';

export const contactDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    postalCode: 'postalCode',
    streetNr: 'streetNr',
    town: 'town',
    county: 'county',
    countryCode: 'countryCode',
    telephone: 'telephone',
    mobilePhone: 'mobilePhone',
    email: 'email',
    description: 'description',
    deleted: 'deleted',
    inactive: 'inactive',
    contactTypesDto: 'contactTypesDto',
    photoBoxDto: 'photoBoxDto',
} as const;

export type TContactDto = (typeof contactDto)[keyof typeof contactDto];

export const contactDtoConstraints = {
    name: { maxLength: 40, minLength: 1 },
    countryCode: { required: true, maxLength: 2, minLength: 2 },
} as const;

export type TContactDtoConstraints = typeof contactDtoConstraints;

export interface IContactDto extends ILevelDomainDto {
    [contactDto.guid]: string | null;
    [contactDto.nr]: number | null;
    [contactDto.name]: string | null;
    [contactDto.postalCode]: string | null;
    [contactDto.streetNr]: string | null;
    [contactDto.town]: string | null;
    [contactDto.county]: string | null;
    [contactDto.countryCode]: string | null;
    [contactDto.telephone]: string | null;
    [contactDto.mobilePhone]: string | null;
    [contactDto.email]: string | null;
    [contactDto.description]: string | null;
    [contactDto.deleted]: boolean | null;
    [contactDto.inactive]: boolean | null;
    [contactDto.contactTypesDto]: IContactTypeDto[] | null;
    [contactDto.photoBoxDto]: IImageBoxDto | null;
}

export class ContactDto
    implements IContactDto
{
    [contactDto.guid]: string | null = null;
    [contactDto.nr]: number | null = null;
    [contactDto.name]: string | null = null;
    [contactDto.postalCode]: string | null = null;
    [contactDto.streetNr]: string | null = null;
    [contactDto.town]: string | null = null;
    [contactDto.county]: string | null = null;
    [contactDto.countryCode]: string | null = null;
    [contactDto.telephone]: string | null = null;
    [contactDto.mobilePhone]: string | null = null;
    [contactDto.email]: string | null = null;
    [contactDto.description]: string | null = null;
    [contactDto.deleted]: boolean | null = null;
    [contactDto.inactive]: boolean | null = null;
    [contactDto.contactTypesDto]: IContactTypeDto[] | null = null;
    [contactDto.photoBoxDto]: IImageBoxDto | null = null;

    private constructor(
        modelData?: IContactData, includeRefs = true,
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[contactDto.guid] = modelData[contactData.guid]
        this[contactDto.nr] = modelData[contactData.nr]
        this[contactDto.name] = modelData[contactData.name]
        this[contactDto.streetNr] = modelData[contactData.streetNr]
        this[contactDto.postalCode] = modelData[contactData.postalCode]
        this[contactDto.town] = modelData[contactData.town]
        this[contactDto.county] = modelData[contactData.county]
        this[contactDto.countryCode] = modelData[contactData.countryCode]
        this[contactDto.telephone] = modelData[contactData.telephone]
        this[contactDto.mobilePhone] = modelData[contactData.mobilePhone]
        this[contactDto.email] = modelData[contactData.email]
        this[contactDto.description] = modelData[contactData.description]
        this[contactDto.deleted] = modelData[contactData.deleted]

         if (!includeRefs) return;

         this[contactDto.contactTypesDto] = modelData[contactData.contactTypes]
             ?.map(item => ContactTypeDto.create(item))
             .filter((a): a is IContactTypeDto => a !== null)
             .sort((a, b) => (a[contactTypeDto.description] ?? '').localeCompare(b[contactTypeDto.description] ?? ''))
             ?? null;
    }

    static create(modelData?: IContactData | null, includeRefs = true): IContactDto | null {
        return modelData ? new ContactDto(modelData, includeRefs) : null;
    }
}
